import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mm-legacy-redirect-landing-page',
  templateUrl: './legacy-redirect-landing-page.component.html',
  styleUrls: ['./legacy-redirect-landing-page.component.scss']
})
export class LegacyRedirectLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    //@ts-ignore
    if (window.utag_data) {
      //@ts-ignore
      window.utag_data.page_name = 'Money Movement UI - landing page'
    }
  }
}
